import { Fragment, useCallback, useState } from 'react';

import { MobileFilterButton } from '~/pages/couples/explore/components/SearchResults/components/MobileFilterButton/MobileFilterButton';
import { AllFacetParentKey } from '~/types/types';

import { useSearchResultsPageContext } from '../../contexts/SearchResultsPageContext';
import { useVendorSearchNavigation } from '../../contexts/VendorSearchNavigationContext';
import { FacetSideDrawer } from '../SearchControls/facets/FacetSideDrawer/FacetSideDrawer';
import { useSearchCategories } from '../SearchControls/useSearchCategories';

import styles from './mobileSearchFilters.module.less';

export const MobileSearchFilters = () => {
  const { vendorSearch } = useSearchResultsPageContext();
  const { navigateToSrp } = useVendorSearchNavigation();
  const [drawerOpenTo, setDrawerOpenTo] = useState<null | true | AllFacetParentKey>(null);
  const allFacetCategories = useSearchCategories(vendorSearch);

  const clearFilters = useCallback(() => {
    navigateToSrp({
      awardGroups: null,
      selectedFacets: null,
      price: null,
      capacity: null,
      searchTerm: null,
      availabilityDates: null,
      metroTypes: null,
      catererTypes: null,
      page: undefined,
    });
  }, [navigateToSrp]);

  return (
    <Fragment>
      {/* This is in fixed position */}
      {Boolean(drawerOpenTo) && (
        <FacetSideDrawer
          drawerOpenTo={drawerOpenTo}
          onClose={() => setDrawerOpenTo(null)}
          categories={allFacetCategories}
          clearFilters={clearFilters}
          className={styles.facetSideDrawer}
        />
      )}

      <MobileFilterButton setDrawerOpenTo={setDrawerOpenTo} />
    </Fragment>
  );
};
